export default {
    en: {
      "1": "Approve",
      "2": "Deny"
    },
    ja: {
      "1": "承認",
      "2": "拒否"
    },
    ko: {
      "1": "승인",
      "2": "거부"
    },
    'zh-CN': {
      "1": "批准",
      "2": "拒绝"
    },
    'zh-TW': {
      "1": "批准",
      "2": "拒絕"
    }
  }
